(function () {
  'use strict';
  const root = document.querySelector('.daluca-pdp--apple-standard');
  if (!root || root.dataset.dalucaColorZoomBound) return;
  root.dataset.dalucaColorZoomBound = 'true';
  const dialog = document.createElement('dialog');
  dialog.className = 'daluca-color-lightbox';
  const heading = document.createElement('h2');
  heading.id = 'daluca-color-lightbox-title';
  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'daluca-color-lightbox__close';
  window.DaLucaI18n.setText(close, '×');
  close.setAttribute('aria-label', root.dataset.dalucaCloseColor);
  const image = document.createElement('img');
  image.className = 'daluca-color-lightbox__image';
  dialog.setAttribute('aria-labelledby', heading.id);
  dialog.append(close, heading, image);
  document.body.appendChild(dialog);
  let opener;
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('daluca-color-lightbox-open');
    if (opener && opener.isConnected) opener.focus({preventScroll: true});
  });
  function organizeOptions() {
    const purchase = root.querySelector('.add_to_cart_holder');
    const options = purchase && purchase.querySelector('.gpo-container');
    if (options) purchase.parentElement.insertBefore(options, purchase);
    const nativeOptions = root.querySelector('variant-selects:not(.variant-selects--sticky)');
    if (purchase && nativeOptions && nativeOptions.parentElement !== purchase.parentElement) purchase.parentElement.insertBefore(nativeOptions, purchase);
    const titles = {1: 'Choose your Apple Watch size', 2: 'Choose your strap', 3: 'Finishing details'};
    root.querySelectorAll('.variations, .gpo-app').forEach(container => {
      Array.from(container.children).filter(field => field.matches('.product-form__input, .gpo-element')).forEach(field => {
        const label = field.querySelector('.form__label, .gpo-label');
        if (!label) return;
        const text = window.DaLucaI18n.sourceText(label).toLowerCase();
        const step = /apple.*size/.test(text) ? 1 : /length|leather|nylon|strap colou?r/.test(text) ? 2 : 3;
        let group = container.querySelector('[data-apple-step="' + step + '"]');
        if (!group) {
          group = document.createElement('section');
          group.className = 'daluca-apple-order-step';
          group.dataset.appleStep = step;
          const heading = document.createElement('h2');
          heading.className = 'daluca-apple-order-step__heading';
          const number = document.createElement('span'); window.DaLucaI18n.setText(number, '0' + step);
          heading.append(number, document.createTextNode(titles[step]));
          group.appendChild(heading);
          container.insertBefore(group, field);
        }
        group.appendChild(field);
      });
      const groups = Array.from(container.children).filter(child => child.hasAttribute('data-apple-step'));
      groups.sort((a, b) => Number(a.dataset.appleStep) - Number(b.dataset.appleStep));
      groups.forEach((group, index) => {
        const current = Array.from(container.children).filter(child => child.hasAttribute('data-apple-step'));
        if (current[index] !== group) container.insertBefore(group, current[index]);
      });
    });
    if (purchase && !purchase.querySelector('.daluca-apple-order-step__heading')) {
      purchase.classList.add('daluca-apple-order-step');
      const heading = document.createElement('h2');
      heading.className = 'daluca-apple-order-step__heading';
      const number = document.createElement('span'); window.DaLucaI18n.setText(number, '04');
      heading.append(number, document.createTextNode('Complete your order'));
      purchase.prepend(heading);
    }
  }
  function independentCare() {
    root.querySelectorAll('.gpo-element').forEach(field=>{
      const label=field.querySelector('.gpo-label .label-content');
      if(!label||!/venetian\s*cream/i.test(window.DaLucaI18n.sourceText(label)))return;
      const no=Array.from(field.querySelectorAll('input[type="radio"]')).find(input=>/^no$/i.test(input.value));
      if(no&&!no.checked){no.checked=true;no.dispatchEvent(new Event('input',{bubbles:true}));no.dispatchEvent(new Event('change',{bubbles:true}));}
      field.hidden=true;field.style.setProperty('display','none','important');

    });
  }
  let careCart = null;
  let careRequest = 0;
  let careBusy = false;
  let purchaseVersion = 0;
  const editKey = new URLSearchParams(location.search).get('dl_edit') || '';
  const selectionKey = 'daluca-apple-care-selections-v1:' + root.dataset.handle + (editKey ? ':edit:' + editKey : '');
  let careSelections = {};
  function restoreCareSelections() {
    try { careSelections = JSON.parse(sessionStorage.getItem(selectionKey) || '{}') || {}; }
    catch (_) { careSelections = {}; }
  }
  function saveCareSelections() {
    try {
      if (Object.keys(careSelections).length) sessionStorage.setItem(selectionKey, JSON.stringify(careSelections));
      else sessionStorage.removeItem(selectionKey);
    } catch (_) {}
  }
  function careItem(cart, id) {
    return (cart?.items || []).find(item => String(item.variant_id || item.id) === String(id) &&
      !item.selling_plan_allocation && item.properties?.['_DaLuca care item'] === 'true' &&
      Object.keys(item.properties || {}).every(key => key === '_DaLuca care item'));
  }
  function applyCareCart(cart) {
    careCart = cart;
    Object.keys(careSelections).forEach(id => {
      const item = careItem(cart, id);
      if (!item || Number(item.quantity) < 1) delete careSelections[id];
      else careSelections[id] = { unitCents: Number(item.final_price ?? item.price ?? careSelections[id].unitCents) };
    });
    saveCareSelections();
  }
  function clearCareSelections() {
    purchaseVersion++;
    careRequest++;
    careSelections = {};
    saveCareSelections();
    updateCareSummary();
  }
  restoreCareSelections();
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: root.dataset.dalucaCurrencyCode || 'USD'
    }).format(cents / 100);
  }
  function setText(node, value) { if(node && window.DaLucaI18n.sourceText(node) !== value) window.DaLucaI18n.setText(node, value); }
  function updateCareSummary() {
    const purchase = root.querySelector('.add_to_cart_holder');
    if(!purchase) return;
    const template = root.querySelector('[data-apple-care-template]');
    const group = root.querySelector('[data-apple-step="3"]');
    if(group && template && !group.querySelector('.daluca-apple-care')) group.appendChild(template.content.cloneNode(true));
    if(!template) return;
    const labels=template.dataset;
    let summary = purchase.querySelector('.daluca-apple-order-totals');
    if(!summary) {
      summary = document.createElement('dl');
      summary.className = 'daluca-apple-order-totals';
      summary.setAttribute('aria-live','polite');
      [['strapSubtotal','appleStrapSubtotal'],['total','appleOrderTotal']].forEach(([label,key])=>{
        const row=document.createElement('div'),term=document.createElement('dt'),value=document.createElement('dd');
        window.DaLucaI18n.setText(term, labels[label]);value.dataset[key]='';row.append(term,value);summary.append(row);
      });
      purchase.querySelector('.daluca-apple-order-step__heading').after(summary);
    }
    const quantity = Math.max(1,Number(purchase.querySelector('input[name="quantity"]')?.value)||1);
    const unitText=window.DaLucaI18n.chainText(() => (root), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['.product-price-container ins .amount']}, {kind:"text", optional:true}]) || '';
    const parts=new Intl.NumberFormat(document.documentElement.lang || 'en-US').formatToParts(1234.56);
    const groupMark=parts.find(part=>part.type==='group')?.value || ',';
    const decimalMark=parts.find(part=>part.type==='decimal')?.value || '.';
    const unitValue=Number(unitText.split(groupMark).join('').replace(decimalMark,'.').replace(/[^0-9.-]/g,''));
    const unitCents=unitValue>0?Math.round(unitValue*100):Number(root.dataset.dalucaBasePriceCents||0);
    const strapCents=unitCents*quantity;
    const button=root.querySelector('.single-add-to-cart-button[name="add"]');
    if(button && !button.disabled && !button.classList.contains('loading')) {
      const baseLabel=(button.dataset.dalucaBaseLabel || window.DaLucaI18n.chainText(() => (button), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => [':scope>span']}, {kind:"text", optional:true}]) || 'Add to cart').split(' — ')[0];
      button.dataset.dalucaBaseLabel=baseLabel;
      setText(button.querySelector(':scope>span'),baseLabel+' — '+money(strapCents));
    }
    let careCents = 0;
    root.querySelectorAll('.daluca-apple-care [data-dl-cart-aov-toggle]').forEach(button=>{
      const selected = careSelections[button.dataset.variantId];
      const count = selected ? 1 : 0;
      const itemCents = selected ? Number(selected.unitCents ?? button.dataset.priceCents ?? 0) : 0;
      careCents += itemCents;
      let itemRow = summary.querySelector('[data-apple-care-line="' + button.dataset.variantId + '"]');
      if (!itemRow) {
        itemRow = document.createElement('div');
        itemRow.dataset.appleCareLine = button.dataset.variantId;
        itemRow.append(document.createElement('dt'), document.createElement('dd'));
        summary.lastElementChild.before(itemRow);
      }
      itemRow.hidden = count <= 0;
      setText(itemRow.querySelector('dt'), button.getAttribute('aria-label') + ' × ' + count);
      setText(itemRow.querySelector('dd'), money(itemCents));
      button.disabled = careBusy;
      button.classList.toggle('is-busy', careBusy);
      if(!careBusy) {
        button.setAttribute('aria-pressed',count>0?'true':'false');
        button.classList.toggle('is-selected',count>0);
        button.closest('[data-dl-cart-aov-card]').classList.toggle('is-selected',count>0);
        setText(button,count>0?labels.remove:labels.add);
      }
      const note=button.closest('[data-dl-cart-aov-card]').querySelector('[data-apple-care-quantity]');
      note.hidden=count<=0;setText(note,labels.inCart.replace('[count]',count));
    });
    setText(summary.querySelector('[data-apple-strap-subtotal]'),money(strapCents));
    setText(summary.querySelector('[data-apple-order-total]'),money(strapCents+careCents));
  }
  async function careRequestJson(path, body) {
    const base = String(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    const response = await fetch(base + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || Number(data.status) >= 400) throw new Error(data.description || data.message || 'Unable to update this care item.');
    return data;
  }
  async function syncCareCart(event) {
    if (careBusy) return;
    const request = ++careRequest;
    try {
      const cart = event?.detail?.cart?.items ? event.detail.cart : await careRequestJson('cart.js');
      if (request === careRequest && !careBusy) { applyCareCart(cart); updateCareSummary(); }
    } catch (_) {}
  }
  root.dataset.dalucaAppleCareBound = 'true';
  root.addEventListener('click', async event => {
    const button = event.target.closest('.daluca-apple-care [data-dl-cart-aov-toggle]');
    if (!button || !root.contains(button)) return;
    event.preventDefault();
    event.stopPropagation();
    if (careBusy || button.disabled) return;
    const id = String(button.dataset.variantId || '');
    if (!/^\d+$/.test(id)) return;
    const removing = !!careSelections[id];
    const version = purchaseVersion;
    const status = button.closest('[data-dl-cart-aov]')?.querySelector('[data-dl-cart-aov-status]');
    setText(status, '');
    careBusy = true;
    careRequest++;
    updateCareSummary();
    let confirmed = false;
    let updated = null;
    try {
      if (removing) {
        const cart = await careRequestJson('cart.js');
        const item = careItem(cart, id);
        if (item) updated = await careRequestJson('cart/change.js', { id: item.key, quantity: Math.max(0, Number(item.quantity) - 1) });
        else updated = cart;
        if (version === purchaseVersion) delete careSelections[id];
      } else {
        const result = await careRequestJson('cart/add.js', { items: [{ id: Number(id), quantity: 1, properties: { '_DaLuca care item': 'true' } }] });
        const item = result.items?.find(item => String(item.variant_id || item.id) === id) || result;
        if (version === purchaseVersion) careSelections[id] = { unitCents: Number(item.final_price ?? item.price ?? button.dataset.priceCents ?? 0) };
      }
      confirmed = true;
      saveCareSelections();
      if (!updated) updated = await careRequestJson('cart.js');
      applyCareCart(updated);
      setText(status, removing ? 'Removed one from your cart.' : 'Added to your cart.');
    } catch (error) {
      setText(status, confirmed ? 'Your cart was updated. Refresh the cart if its totals have not updated.' : error.message || 'Unable to update this care item.');
    } finally {
      careBusy = false;
      updateCareSummary();
      if (confirmed) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: updated ? { cart: updated } : {} }));
    }
  });
  document.addEventListener('cart:item-added', event => {
    const product = event.detail?.product;
    const id = String(product?.variant_id || product?.id || '');
    const mainId = String(root.querySelector('form[action*="/cart/add"] [name="id"]')?.value || root.dataset.dalucaMainVariantId || '');
    if (id && (id === mainId || String(product?.product_id || '') === root.dataset.dalucaMainProductId)) clearCareSelections();
    syncCareCart(event);
  });
  document.addEventListener('cart:updated', event => {
    if (editKey && event.detail?.source === 'daluca-cart-edit') clearCareSelections();
  });
  ['cart:refresh','line-item:change:end'].forEach(name => document.addEventListener(name, syncCareCart));
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    restoreCareSelections();
    updateCareSummary();
    syncCareCart();
  });
  root.addEventListener('input',()=>requestAnimationFrame(updateCareSummary));
  root.addEventListener('change',()=>requestAnimationFrame(updateCareSummary));
  // Keep Globo's native radios and change handlers; only expose the existing
  // image choices to keyboards and assistive technology.
  function accessibleImageSwatches() {
    if (!root.querySelector('style[data-daluca-image-swatch-a11y]')) {
      const style = document.createElement('style');
      style.dataset.dalucaImageSwatchA11y = '';
      window.DaLucaI18n.setText(style, `
        .daluca-pdp--apple-standard .gpo-swatches input.daluca-apple-image-choice:not([hidden]) {
          display: block !important;
          position: absolute !important;
          width: 1px !important;
          height: 1px !important;
          padding: 0 !important;
          margin: -1px !important;
          overflow: hidden !important;
          clip: rect(0, 0, 0, 0) !important;
          clip-path: inset(50%) !important;
          white-space: nowrap !important;
          border: 0 !important;
        }
        .daluca-pdp--apple-standard .gpo-swatches input.daluca-apple-image-choice:focus-visible + label {
          outline: 2px solid #223a56 !important;
          outline-offset: 3px !important;
        }
      `);
      root.prepend(style);
    }
    root.querySelectorAll('.gpo-swatches input[type="radio"][data-type="image-swatches"]').forEach(input => {
      const label = Array.from(input.labels || []).find(node => root.contains(node));
      if (!label) return;
      const field = input.closest('.gpo-element');
      const title = (input.getAttribute('data-field-name') || input.name || window.DaLucaI18n.chainText(() => (field), [{kind:"member", optional:true, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['.gpo-label .label-content']}, {kind:"text", optional:true}]) || '').trim();
      const name = (title ? title + ': ' : '') + input.value;
      input.classList.add('daluca-apple-image-choice');
      if (input.getAttribute('aria-label') !== name) input.setAttribute('aria-label', name);
      label.querySelectorAll('img:not([alt])').forEach(image => image.alt = '');
    });
  }

  function attach() {
    accessibleImageSwatches();
    organizeOptions();
    independentCare();
    updateCareSummary();
    root.querySelectorAll('.gpo-element').forEach(field => {
      const label = field.querySelector('.gpo-label .label-content');
      if (label && /adapter/i.test(window.DaLucaI18n.sourceText(label))) field.classList.add('daluca-apple-adapter-field');
      if (!label || !/^leather colou?r$/i.test(window.DaLucaI18n.sourceText(label).trim())) return;
      field.classList.add('daluca-apple-leather-colors');
      field.querySelectorAll('.gpo-swatches').forEach(swatch => {
        if (swatch.querySelector('.daluca-color-zoom-button')) return;
        const input = swatch.querySelector('input[type="radio"]');
        const swatchImage = swatch.querySelector('.swatch-image');
        if (!input || !swatchImage) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'daluca-color-zoom-button';
        button.setAttribute('aria-label', root.dataset.dalucaEnlargeColor + ': ' + input.value);
        button.setAttribute('aria-haspopup', 'dialog');
        window.DaLucaI18n.setHtml(button, '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6M7 10h6M10 7v6"/></svg>');
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          const large = swatch.querySelector('.gpo-tooltip__image img');
          const url = new URL((large || swatchImage).src, location.href);
          url.searchParams.set('width', '1200');
          url.searchParams.delete('height');
          window.DaLucaI18n.setText(heading, root.dataset.dalucaColorHeading + ' — ' + input.value);
          image.alt = input.value;
          image.src = url.href;
          opener = button;
          dialog.showModal();
          document.documentElement.classList.add('daluca-color-lightbox-open');
          close.focus();
        });
        swatch.appendChild(button);
      });
    });
  }
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; attach(); });
  });
  observer.observe(root, {childList: true, subtree: true});
  attach();
  syncCareCart();
})();



